// extracted by mini-css-extract-plugin
export var connectionButton = "_94-1";
export var rightPanel = "_94-3";
export var stepDescription = "_94-2";
export var stepIcon = "_94-0";